import flatpickr from 'flatpickr';
import type { Options } from 'flatpickr/dist/types/options';

export const datepicker = (element: HTMLElement, options: Options) => {
	flatpickr(element, options);

	return {
		update(options: Options) {
			flatpickr(element, options);
		}
	};
};
